<mat-list class="px-3">
  <mat-list-item>
    <div class="w-100 text-center">
      <mat-icon class="md-48" (click)="switchTheme()">account_circle</mat-icon>
    </div>
  </mat-list-item>
  <mat-list-item class="text-center">
    <span matListItemTitle>{{fullName}}</span>
    <span matListItemLine>{{emailAddress}}</span>
  </mat-list-item>
  <mat-list-item>
    <a mat-button href="{{accountUrl}}" target="_blank" rel="norefferer" class="w-100">Manage Account</a>
  </mat-list-item>
  <mat-divider></mat-divider>
  @if (isServiceWorkerEnabled) {
    <mat-list-item>
      <button mat-button (confirm)="resetApp()" xuiConfirmationDialog confirmTitle="Reset Application Cached Data" confirmMessage="This will clear all cached data and reload the app. Continue?"  class="w-100 text-danger">Reset App</button>
    </mat-list-item>
  }
  <mat-list-item lines="2">
    <span matListItemTitle class="text-center d-block">
      <button mat-button (click)="logout()" class="w-100">Logout</button>
    </span>
    <span matListItemLine class="text-center" (click)="checkUpdates()" style="cursor: pointer;">{{versionText}}</span>
  </mat-list-item>
</mat-list>
@if (updating) {
  <xui-loading-bar></xui-loading-bar>
}
